import { FundInvestmentRowConfigProps } from './fundInvestmentRowConfig.props';
import {
  contentClass,
  headerClass,
  OFFSET_TO_STARTING_ROW,
  subtitleClass,
  totalClassAlignRight,
} from '../../constants';

const fundInvestmentRowConfig = ({ fundShare }: FundInvestmentRowConfigProps) => {
  const { fund, share_values: shareValues } = fundShare;
  const totalExpression = shareValues.length ? `=SUM(${shareValues.map((_, i) => `@${i + 3}`).join(',')})` : '=0';
  return [
    {
      value: fund.name,
      readOnly: true,
      colSpan: 2,
      className: `${headerClass}`,
    },
    {
      value: '',
      alias: 'subtitle',
      readOnly: true,
      className: subtitleClass,
      largeHeader: true,
    },
    ...shareValues.map((shareValue, index) => ({
      value: shareValue.shares,
      alias: 'shares',
      className: contentClass,
      expr: `=A${index + OFFSET_TO_STARTING_ROW} * ${shareValue.per_share}`,
    })),
    {
      value: 'Total',
      readOnly: true,
      expr: totalExpression,
      className: totalClassAlignRight,
    },
  ];
};

export default fundInvestmentRowConfig;
